export default __webpack_public_path__ + "static/media/mussel-app.f0c142cb.png";